import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "nave-main__ws-main__text mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_side_menu_nave = _resolveComponent("side-menu-nave")!
  const _component_nav_menu_nave = _resolveComponent("nav-menu-nave")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nave-main d-flex align-items-stretch", _ctx.getClassTheme])
  }, [
    _createVNode(_component_Toast),
    (_ctx.account)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_side_menu_nave, { sidebar: _ctx.optionsMenu }, null, 8, ["sidebar"]),
          _createElementVNode("main", {
            class: _normalizeClass(["nave-main__main d-flex flex-column", _ctx.embeddedIframe ? '' : 'padding-bottom'])
          }, [
            _createVNode(_component_nav_menu_nave),
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component, route }) => [
                _createVNode(_Transition, { name: "fade-in-up" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("section", {
                      key: route.name ? route.matched[0].name : route.name
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.embeddedIframe ? '' : ['nave-c-px-4', 'container']])
                      }, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                      ], 2)
                    ]))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ], 2)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_Toast, {
      class: "nave-main__ws-main",
      position: "bottom-right",
      group: "ws"
    }, {
      message: _withCtx((slotProps) => [
        _createElementVNode("p", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "icon-nav-check" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(slotProps.message.detail) + " ", 1),
          _createElementVNode("i", {
            class: "icon-nav-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeToastGroup('ws')))
          })
        ])
      ]),
      _: 1
    })
  ], 2))
}